module.exports = "/assets/site/images/Rectangle 17.png?03c44bc91541dd394136d1258e92e1b9";